import styled from 'styled-components';
export const StyledFlexbox = styled.div.withConfig({
  componentId: "Flexbox__sc-1yjv98p-0"
})(["", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", " ", ""], ({
  display
}) => display && `display: ${display}`, ({
  flexDirection
}) => flexDirection && `flex-direction: ${flexDirection}`, ({
  justifyContent
}) => justifyContent && `justify-content: ${justifyContent}`, ({
  alignItems
}) => alignItems && `align-items: ${alignItems}`, ({
  alignSelf
}) => alignSelf && `align-self: ${alignSelf}`, ({
  alignContent
}) => alignContent && `align-content: ${alignContent}`, ({
  flexBasis
}) => flexBasis && `flex-basis: ${flexBasis}`, ({
  flexGrow
}) => flexGrow && `flex-grow: ${flexGrow}`, ({
  flexShrink
}) => flexShrink && `flex-shrink: ${flexShrink}`, ({
  flexWrap
}) => flexWrap && `flex-wrap: ${flexWrap}`, ({
  order
}) => order && `order: ${order}`, ({
  gap
}) => gap && `gap: ${String(gap).split(' ').map(gp => `${gp}px`).join(' ')};`, ({
  margins,
  flexDirection
}) => margins && (Array.isArray(margins) ? margins.map((indent, i) => `
						& > *:nth-child(${i + 2}) {
							margin-${(flexDirection || 'row').search('column') ? 'left' : 'top'}: ${indent}px;
						}`) : `& > *:not(:first-child) {
					margin-${(flexDirection || 'row').search('column') ? 'left' : 'top'}: ${margins}px;
				}`));